import { useState } from "react";
import { openAlert } from "../components/Modal/MsgBox";

const useFiles = (limit = 5) => {
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    if (!e.target.files) return;
    if (files.length + e.target.files.length > limit) {
      openAlert(`첨부파일은 ${limit}개까지\n업로드할 수 있습니다.`);
      return;
    }

    const selectedFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...selectedFiles]);
    e.target.value = "";
  };

  const deleteFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const toFormData = (request) => {
    const formData = new FormData();
    formData.append(
      "request",
      new Blob([JSON.stringify(request)], { type: "application/json" }),
    );
    files.forEach((f) => formData.append("files", f));

    return formData;
  };

  return [files, handleFileChange, deleteFile, toFormData];
};

export default useFiles;
